/* eslint-disable react/prop-types */
import React from 'react';
import { RichText } from '@fiverr-private/cms_ui';
import { getContext } from '@fiverr-private/fiverr_context';

import { getEmbeddedComponents } from '../../constants';

export const Container = ({ alignment, content, customClassName, showInSelectedCountries = [] }) => {
    const { countryCode } = getContext();

    if (!showInSelectedCountries.length || showInSelectedCountries.includes(countryCode.toUpperCase())) {
        return (
            <div style={{ textAlign: alignment }} className={customClassName}>
                {content && <RichText {...content} embeddedComponents={getEmbeddedComponents()} />}
            </div>
        );
    }

    return null;
};
